import React, { useState } from "react";
import Layout, { Container } from "../components/layout";

// Ticket Creation Form Component
const TicketForm = () => {
  const [subject, setSubject] = useState("");
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission (e.g., send data to backend)
    alert("Ticket submitted!");
  };

  

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-lg mx-auto mt-10">
      <h2 className="text-2xl font-semibold mb-6">Raise a New Ticket</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full mt-2 p-3 border border-gray-300 rounded-md"
            placeholder="e.g., Incorrect Salary Slip – March"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full mt-2 p-3 border border-gray-300 rounded-md"
            required
          >
            <option value="">Select Category</option>
            <option value="Payslip Issue">Payslip Issue</option>
            <option value="Leave Discrepancy">Leave Discrepancy</option>
            <option value="Tax Deduction">Tax Deduction</option>
            <option value="Bonus/Allowance">Bonus/Allowance</option>
            <option value="Others">Others</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full mt-2 p-3 border border-gray-300 rounded-md"
            rows="5"
            placeholder="Describe your issue..."
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Attach Document (Optional)</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            className="w-full mt-2 p-3 border border-gray-300 rounded-md"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-500 text-white px-6 py-3 rounded-md mt-4 w-full hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Submit Ticket
        </button>
      </form>
    </div>
  );
};

// Ticket Table Component
const TicketTable = () => {
  const [openModal, setOpenModal] = useState(false);
  const tickets = [
    { id: "#TKT1234", subject: "Payslip Missing", category: "Payslip Issue", status: "Open", date: "2025-05-01" },
    // Add more tickets here
  ];

  const toggleModal = () => setOpenModal(!openModal);

  return (
    <div className="overflow-x-auto bg-white p-6 rounded-2xl shadow-lg max-w-full mt-10">
      <h2 className="text-2xl font-semibold mb-6">My Tickets</h2>
      <table className="min-w-full text-left text-sm">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">Ticket ID</th>
            <th className="py-2 px-4 border-b">Subject</th>
            <th className="py-2 px-4 border-b">Category</th>
            <th className="py-2 px-4 border-b">Status</th>
            <th className="py-2 px-4 border-b">Date Raised</th>
            <th className="py-2 px-4 border-b">Action</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket, index) => (
            <tr key={index}>
              <td className="py-2 px-4 border-b">{ticket.id}</td>
              <td className="py-2 px-4 border-b">{ticket.subject}</td>
              <td className="py-2 px-4 border-b">{ticket.category}</td>
              <td className="py-2 px-4 border-b">
                <span
                  className={`py-1 px-3 rounded-full ${
                    ticket.status === "Open"
                      ? "bg-blue-50 text-blue-700"
                      : "bg-gray-50 text-gray-700"
                  }`}
                >
                  {ticket.status}
                </span>
              </td>
              <td className="py-2 px-4 border-b">{ticket.date}</td>
              <td className="py-2 px-4 border-b">
                <button
                  onClick={toggleModal}
                  className="text-blue-500 hover:underline"
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal for Calendar & Ticket Details */}
      {openModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-96">
            <h2 className="text-xl font-semibold mb-4">Attendance Calendar - May 2025</h2>
            {/* Render your calendar here */}
            <div className="mt-4 flex gap-4 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#7DA0FA]" /> Present
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#F3797E]" /> Absent
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#98BDFF]" /> Leave
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#4B49AC]" /> Holiday
              </div>
            </div>
            <div className="mt-4">
              <button
                onClick={toggleModal}
                className="bg-blue-500 text-white px-6 py-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Main Help Page Component
const HelpPage = () => {
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="container mx-auto p-6">
          <TicketForm />
          <TicketTable />
        </div>
      </Container>
    </Layout>
  );
};

export default HelpPage;
